export type HttpHeader = {
  name: string;
  value: string;
};

// modal state value of CustomHttpHeaders
export type CustomHttpHeaders = Record<string, HttpHeader & { id: string }>;

export type RateLimitValue = number | null | undefined;

export type NewDataFeed = {
  alias?: string;
  authToken?: string;
  customHttpHeaders: HttpHeader[];
  format: FEED_FORMATS;
  name: string;
  rateLimitPerMin?: RateLimitValue;
  url: string;
};

export type DataFeed = NewDataFeed & {
  createdAt: number; // epoch
  id: number;
  projectId: number;
};

// api return for { data }: /integrations/dataFeeds.json
export type DataFeeds = Record<string, DataFeed>;

export enum FEED_FORMATS {
  ATOM = 'Atom',
  JSON = 'JSON',
  RSS = 'RSS',
  XML = 'XML',
}

export enum DATA_FEEDS_MODAL_TYPE {
  ALIAS = 'data-feed-modal/alias',
  DELETE = 'data-feed-modal/delete',
  EDIT = 'data-feed-modal/edit',
}

// The id should equal the api return field which contains the data
export enum TABLE_COLUMN_ID {
  ALIAS = 'alias',
  BUTTON = 'button',
  CREATED = 'createdAt',
  FEED_NAME = 'name',
  FEED_URL = 'url',
  FORMAT = 'format',
  ID = 'id',
  RATE_LIMIT = 'rateLimitPerMin',
}
